// extracted by mini-css-extract-plugin
export default {"infoContainer":"styles_infoContainer__jjjZl","accent":"styles_accent__GOXMA","title":"styles_title__DS-NQ"};